<app-dropdown
  [closeMethod]="closeMethod"
  [title]="'dropdown-alerts.title.alert-notifications' | translate"
>
  @if (rowsLoading()) {
    <app-loading></app-loading>
  } @else {
    <div class="alert">
      <div class="body" [class.no-alerts]="rows().length === 0">
        @for (row of rows(); track row.id) {
          <div
            class="single-alert"
            [class.unread]="row.time_read === null"
            role="button"
            tabindex="0"
            (click)="openEvent(row)"
            (keydown.enter)="openEvent(row)"
          >
            <div class="alert-top-row">
              <div class="title">
                <div class="unread-bubble"></div>
                <div>{{ row.alert?.name ?? "—" }}</div>
              </div>
              <div class="last-triggered">
                {{ row.time_triggered?.relative ?? "—" }}
              </div>
            </div>
            <div class="alert-summary">
              <span>{{ row.feed?.name ?? "—" }}</span>
              @if (row.has_trigger) {
                <span>
                  · {{ row.trigger_type?.name ?? "—" }}:
                  {{ row.observed_value }} / {{ row.threshold_value }}
                </span>
              }
            </div>
          </div>
        }
        @if (rows().length === 0) {
          <div class="no-alerts">
            {{ "dropdown-alerts.message.no-alerts" | translate }}
          </div>
        }
      </div>
    </div>
  }
  <div class="view-all" dropdownFooter>
    <sui-button
      variant="secondary"
      [disabled]="markAllRead.isPending() || unreadCount() === 0"
      (click)="markAllAsRead()"
    >
      {{ "dropdown-alerts.button.mark-all-as-read" | translate }}
    </sui-button>
    <sui-button variant="primary" (click)="openStream()">
      {{ "dropdown-alerts.button.view-all" | translate }}
    </sui-button>
  </div>
</app-dropdown>
